import { v4 as uuidv4 } from 'uuid';
import _get from 'lodash/get';

import { selectHelpers } from 'utils/uiKitHelpers';

/**
 * Format Data recevied from server to make it form compatible
 * @param  {Object} data API data
 */
export function createFormDataset(data) {
  if (!data) return data;

  const dataset = { ...data };
  const collections = _get(dataset, 'collections', []);
  const productTypes = _get(dataset, 'product_types', []);
  const excludedTags = _get(dataset, 'excluded_tags', []);
  const productCategories = _get(dataset, 'product_categories', []);

  const productTypesInfo = selectHelpers.createOptions(productTypes, {
    isMulti: true,
    getLabel: type => _get(type, 'title', ''),
    getValue: type => _get(type, 'id', uuidv4()),
    checkIsSelected: type => _get(type, 'visible', false)
  });
  dataset.productTypeOptions = productTypesInfo.options;
  dataset.product_types = productTypesInfo.value;

  const categoriesInfo = selectHelpers.createOptions(productCategories, {
    isMulti: true,
    getValue: category => String(_get(category, 'id', '')),
    checkIsSelected: category => _get(category, 'visible', false)
  });
  dataset.productCategoryOptions = categoriesInfo.options;
  dataset.product_categories = categoriesInfo.value;

  const collectionsInfo = selectHelpers.createOptions(collections, {
    isMulti: true,
    getLabel: collection => _get(collection, 'title', ''),
    getValue: collection => _get(collection, 'id', ''),
    checkIsSelected: collection => _get(collection, 'visible', false)
  });
  dataset.collectionOptions = collectionsInfo.options;
  dataset.collections = collectionsInfo.value;

  dataset.excluded_tags = excludedTags.map(tag => ({ value: tag, label: tag }));

  return dataset;
}

/**
 * Format Data recevied from server to make it form compatible
 * @param  {Object} data API data
 */
export function createFormData(data) {
  if (!data) return {};

  const productTypes = _get(data, 'product_types', []);
  const productCategories = _get(data, 'product_categories', []);
  const collections = _get(data, 'collections', []);
  const excludedTags = _get(data, 'excluded_tags', []);

  const productTypesInfo = selectHelpers.createOptions(productTypes, {
    isMulti: true,
    getLabel: type => _get(type, 'title', ''),
    getValue: type => _get(type, 'id', uuidv4()),
    checkIsSelected: type => _get(type, 'visible', false)
  });

  const categoriesInfo = selectHelpers.createOptions(productCategories, {
    isMulti: true,
    getValue: category => String(_get(category, 'id', '')),
    checkIsSelected: category => _get(category, 'visible', false)
  });

  const collectionsInfo = selectHelpers.createOptions(collections, {
    isMulti: true,
    getLabel: collection => _get(collection, 'title', ''),
    getValue: collection => _get(collection, 'id', ''),
    checkIsSelected: collection => _get(collection, 'visible', false)
  });

  const excludedTagsInfo = selectHelpers.createOptions(excludedTags, {
    getLabel: tag => tag,
    getValue: tag => tag,
    checkIsSelected: () => true
  });

  return {
    formData: {
      productTypes: productTypesInfo.value,
      productCategories: categoriesInfo.value,
      collections: collectionsInfo.value,
      excludedTags: excludedTagsInfo.options,
      minPrice: `${_get(data, 'min_price', 0)}`,
      showDigitalProducts: _get(data, 'show_digital_products', false),
      showSaleItems: _get(data, 'show_sale_items', true)
    },
    productTypeOptions: productTypesInfo.options,
    productCategoryOptions: categoriesInfo.options,
    collectionOptions: collectionsInfo.options
  };
}
